import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=4215fde2&scoped=true&lang=pug"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=4215fde2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215fde2",
  null
  
)

export default component.exports